import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

// Neutral about create-vs-update per the edit-existing-report stretch goal in plan.md.
// PR3 wires the actual save path and may set status to "saved" for either a freshly-built
// config or an updated existing one. Field names stay generic accordingly.
export type ReportSaveStatus = "pending" | "saving" | "saved" | "error";

export type ReportBuilderState = {
	reportConfig: Record<string, unknown> | null;
	savedReportId: string | null;
	status: ReportSaveStatus;
	errorMessage: string | null;
	messageId: string | null;
};

export type ReportSlice = {
	reportBuilder: ReportBuilderState | null;
	// Called from the SSE handler when the interviewer emits an interviewer_output for this harness.
	// PR2 payload is empty; PR3 emits the real config and this sets `reportConfig`.
	setReportConfig: (messageId: string, reportConfig: Record<string, unknown>) => void;
	setReportSaveStatus: (status: ReportSaveStatus, errorMessage?: string | null) => void;
	setSavedReportId: (savedReportId: string | null) => void;
	clearReportBuilder: () => void;
};

export const createReportSlice = (set: SetState<AskPerformYardState>): ReportSlice => ({
	reportBuilder: null,

	setReportConfig: (messageId, reportConfig) => {
		set(() => ({
			reportBuilder: {
				reportConfig,
				savedReportId: null,
				status: "pending",
				errorMessage: null,
				messageId,
			},
		}));
	},

	setReportSaveStatus: (status, errorMessage = null) => {
		set((state) => {
			if (!state.reportBuilder) return state;
			return { reportBuilder: { ...state.reportBuilder, status, errorMessage } };
		});
	},

	setSavedReportId: (savedReportId) => {
		set((state) => {
			if (!state.reportBuilder) return state;
			return { reportBuilder: { ...state.reportBuilder, savedReportId } };
		});
	},

	clearReportBuilder: () => set({ reportBuilder: null }),
});
